export default __webpack_public_path__ + "icon-clock.png";